import { render, staticRenderFns } from "./pr-consolidated-items.vue?vue&type=template&id=7b965984&"
import script from "./pr-consolidated-items.vue?vue&type=script&lang=js&"
export * from "./pr-consolidated-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports